import type { FormLayoutPage } from '../../../../../forms'
import { layoutFields } from './helpers'

export const NotesLayout: FormLayoutPage = {
  key: 'notes',
  title: 'Notes and Photos',
  description: 'Enter any additional notes or observations about the elevator.',
  contents: [layoutFields.generalNotes, layoutFields.photos],
}
